import { useDeviceType } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Door } from 'shared/components/Door';
import { SIXTH_GIFT_DOOR_LINK } from 'shared/constants/links';
import { useAppDispatch } from 'shared/hooks';
import { selectCurrentDate } from 'shared/selectors/currentDate';
import { selectUser } from 'shared/selectors/user';
import { setModalContent } from 'shared/slices';
import { TDoor } from 'shared/types/doors';
import { useApplicationContext } from 'shared/utils/applicationContext';

interface IDoorContainerProps extends Omit<TDoor, 'onClickBtn'> {
  date: string;
  id: number;
  Content: React.FC<Omit<TDoor, 'onClickBtn'>> | null;
}

export const DoorContainer: React.FC<IDoorContainerProps> = ({ title, Content, date, id, ...props }) => {
  const currentDate = new Date(useSelector(selectCurrentDate));

  const { user } = useSelector(selectUser);

  const { image } = props;

  const {
    config,
    custom: { cianUserId },
  } = useApplicationContext();

  const adminsIds = config.get<number[]>('b2b-marketing-advent-calendar-frontend.adminsIds') || [];

  const doorIsCompleted = Boolean(user?.doors.find(item => item.id === id)?.status);

  const doorDate = new Date(date);

  const dateToRender = doorDate.getDate().toString();

  const doorIsDisabled = adminsIds.includes(cianUserId)
    ? false
    : currentDate < doorDate || currentDate > new Date('2026-01-20') || !user;

  const device = useDeviceType();

  const dispatch = useAppDispatch();

  const handleModalContent = useCallback(() => {
    if (doorIsCompleted && id === 6) {
      window.open(SIXTH_GIFT_DOOR_LINK);

      return;
    }

    if (Content && !doorIsDisabled) {
      dispatch(
        setModalContent({
          type: 'door',
          doorId: id,
          props: {
            image,
            title,
          },
        }),
      );
    }
  }, [doorIsCompleted, id, Content, doorIsDisabled, dispatch, image, title]);

  return (
    <Door
      completed={doorIsCompleted}
      date={dateToRender}
      doorIsDisabled={doorIsDisabled}
      device={device}
      onModalContent={handleModalContent}
      {...props}
    />
  );
};
